module.exports = __webpack_public_path__ + "media/images/edit-with-pen-6cfa22ae8b2084a1ff1d46fa9e72eeed.svg";